import React from 'react';
import PageHeader from '../components/PageHeader.tsx';
import EmptyState from '../components/EmptyState.tsx';
import { DataUsage24Regular } from '@fluentui/react-icons';

export default function Analytics() {
  return (
    <div>
      <PageHeader title="Analytics Dashboard" subtitle="View detailed analytics and insights" />
      <div style={{ backgroundColor: 'var(--color-surface)', border: '1px solid var(--color-border-light)', borderRadius: 'var(--radius-md)', padding: 'var(--space-lg)' }}>
        <EmptyState icon={<DataUsage24Regular />} title="Coming soon" description="Analytics dashboard is under development" />
      </div>
    </div>
  );
}
